'use client';

import { useRouter } from '@/i18n/navigation';
import { Flex, Heading } from '@chakra-ui/react';
import { useTranslations } from 'next-intl';
import { GoArrowLeft } from 'react-icons/go';

const AboutHeader = () => {
  const router = useRouter();
  const t = useTranslations('profile');
  return (
    <Flex py="3" alignItems="center" w="full">
      <GoArrowLeft
        size="24"
        strokeWidth="0.75"
        color="#000"
        onClick={() => router.back()}
      />
      <Heading as="h1" size="xl" fontWeight="bold" flex="1" textAlign="center">
        {t('about')}
      </Heading>
    </Flex>
  );
};

export default AboutHeader;
